import Vue from 'vue'
import VueI18n from 'vue-i18n'
import FilterMadamesum from '@/helpers/FilterMadamesum'
import DirectiveHtmlClass from '@/helpers/DirectiveHtmlClass'
import store from '@/store'
import { updateServiceConfig } from '@/service'
import { config, vueConfig, readFromComponentOptions } from '@/config'
import svgs from '@/../svg'
import {toPascal} from '@/utils/convertcase';

let initializedOnce = false
let i18n = null

//plugins
Vue.use(VueI18n)
Vue.use(FilterMadamesum)
Vue.use(DirectiveHtmlClass)

Vue.mixin({
	data() {
		return {
			themeName: config.THEME,
			language: config.LANGUAGE,
			isHome: document.querySelector('.home-intro'),
		}
	},
	methods: {
		isTheme(value) {
			if (config.THEMES.indexOf(value) < 0) {
				throw new Error("Theme not found: " + value)
			}
			return config.THEME == value
		},
		hasFeature(value) {
			if (value && value.indexOf('FEATURE_') == 0 && config[value] != undefined) {
				return config[value]
			} else {
				throw new Error("Feature not valid: " + value)
			}
		},
		themeValue(value) {
			if (value && value.indexOf('THEME_') == 0 && config[value] != undefined) {
				return config[value]
			} else {
				throw new Error("Theme value not valid: " + value)
			}
		},
		langValue(value) {
			if (value && value.indexOf('LANG_') == 0 && config[value] != undefined) {
				return config[value]
			} else {
				throw new Error("Lang value not valid: " + value)
			}
		},
		iconComponent(name) {
			const icon = `SVG${toPascal(name)}`;
			return name && !!svgs[icon] ? icon : '';
		}
	}
})

//do the config directly
export default function(dom, opts) {
	let options = {
		...opts
	}

	//we try to initialize as late as possible
	if (!initializedOnce) {
		//register global components
		if (vueConfig) {
			if (svgs) {
				//apply default svgs but do not override already set
				//TODO: we have to find another mechanic of initialize with multiple root components
				Object.assign(svgs, vueConfig.registerGlobalsComponentMap)
				Object.assign(vueConfig.registerGlobalsComponentMap, svgs)
			}
			Object.entries(vueConfig.registerGlobalsComponentMap)
				.forEach(([k, v]) => Vue.component(k, v))
		}

		dayjs.locale('de')

		i18n = new VueI18n({
			locale: config.LANGUAGE
		})

		initializedOnce = true
	}

	//readFromHtmlJson()
	readFromComponentOptions(options)
	updateServiceConfig()

	// component specific translation
  if (options.i18n) {
    Object.entries(options.i18n)
      .forEach(([k, v]) => {
        i18n.mergeLocaleMessage(k, v)
      })
  }

	let page = new Vue({
		el: dom,
		i18n,
		store,
		data: {
			brand: options.brand,
			options
		},
		render(h, context) {
			return h(options.vueComponent, { })
		},
		created() {
			if (options.vueInit) {
				this.$store.dispatch(options.vueInit, {  })
			}
		}
	})
	return page
}
